import { useToggle } from 'commons/toggle';
import * as Semantic from 'semantic-ui-react';
import { CompositionUsageModal } from './CompositionUsage.modal';
import { NEW_RESOURCE_ID } from 'commons/utils';

type Props = {
  compositionId?: string;
};

export function CompositionUsageMenuItem({ compositionId }: Props) {
  const [modalVisible, toggleModal] = useToggle();
  const validId = !!compositionId && compositionId !== NEW_RESOURCE_ID;

  return (
    <>
      {modalVisible && <CompositionUsageModal compositionId={compositionId!} onClose={toggleModal} />}
      <Semantic.Dropdown.Item icon="list" text="Show usage" disabled={!validId} onClick={toggleModal} />
    </>
  );
}
